import { useLayoutEffect } from "react";
import { useLocation } from "../components/Router/state";

export const useNavigationEffect = (
  callback: (location: Location) => void,
  additionalDependencies: unknown[]
) => {
  const location = useLocation();

  useLayoutEffect(() => {
    callback(location);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, ...(additionalDependencies || [])]);
};
